import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  customerLoading: false,
  paymentHistoryLoding: false,
  plan: {},
  couponInfo: {},
  paymentHistory: {},
  paymentHistoryLoding: {},
  taxInfromation: {}
};

export const stripeIntegrationSlice = createSlice({
  name: "stripeIntegration",
  initialState,
  reducers: {
    createCustomer: (state) => {
      state.customerLoading = true;
    },
    setCreateCustomer: (state, action) => {
      state.customerLoading = false;
    },
    onErrorStopLoad: (state) => {
      state.loading = false;
      state.customerLoading = false;
      state.paymentHistoryLoding = false
    },
    updateCustomer: (state) => {
      state.loading = true;
    },
    setPaymentMethod: (state) => {
      state.loading = false;
    },
    createSubscription: (state) => {
      state.loading = true;
    },
    setCreateSubscription: (state) => {
      state.loading = false;
    },
    setPlanId: (state, action) => {
      state.loading = false;
      state.plan = action.payload;
    },
    deleteACard: (state) => {
      state.customerLoading = true;
    },
    setDeletedCard: (state) => {
      state.customerLoading = false;
    },
    checkCoupon: (state) => {
      state.loading = true;
    },
    setCouponInfo: (state, action) => {
      state.loading = false;
      state.couponInfo = action.payload;
    },
    getPaymentHistory: (state) => {
      state.paymentHistoryLoding = true;
    },
    setPaymentHistory: (state, action) => {
      state.customerLoading = false;
      state.paymentHistoryLoding = action.payload;
    },
    getTaxInformation: (state) => {
      state.loading = true;
    },
    setTaxInformation : (state, action) => {
      state.loading = false;
      state.taxInfromation = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  createCustomer,
  setCreateCustomer,
  onErrorStopLoad,
  updateCustomer,
  setPaymentMethod,
  createSubscription,
  setCreateSubscription,
  setPlanId,
  deleteACard,
  checkCoupon,
  setCouponInfo,
  setDeletedCard,
  getPaymentHistory,
  setPaymentHistory,
  getTaxInformation,
  setTaxInformation
} = stripeIntegrationSlice.actions;

export default stripeIntegrationSlice.reducer;
